export const PageTransition = {
  FromLeft: 'left',
  FromRight: 'right',
  FromTop: 'top',
  FromBottom: 'down',
  FadeIn: 'fadeIn',
  None: 'none',
} as const

export type PageTransition = (typeof PageTransition)[keyof typeof PageTransition]
